import { render } from "./ArticleWindow.vue?vue&type=template&id=08f4889c"
import script from "./ArticleWindow.vue?vue&type=script&lang=js"
export * from "./ArticleWindow.vue?vue&type=script&lang=js"

import "./ArticleWindow.vue?vue&type=style&index=0&id=08f4889c&lang=scss"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__